import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const MissionSection = () => {
  const missionPoints = [
    {
      icon: "Brain",
      title: "AI-Powered Intelligence",
      description: "Our advanced algorithms understand relationships, preferences, and occasions to suggest gifts that truly resonate."
    },
    {
      icon: "Users",
      title: "Community-Driven Insights",
      description: "Learn from a community of thoughtful gift-givers who share experiences and celebrate successful moments."
    },
    {
      icon: "Globe",
      title: "Cultural Awareness",
      description: "Respect and celebrate diverse traditions, ensuring every gift honors the recipient's cultural background."
    },
    {
      icon: "Shield",
      title: "Privacy-First Approach",
      description: "Your personal relationships and preferences are protected with enterprise-grade security and ethical AI."
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl lg:text-5xl font-bold text-accent-800 mb-6">
            Our Mission
          </h2>
          <p className="text-lg lg:text-xl text-accent-600 max-w-3xl mx-auto leading-relaxed">
            We exist at the intersection of technology and human connection, believing that meaningful gift-giving strengthens relationships and creates lasting memories.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16">
          <div>
            <h3 className="font-heading text-2xl lg:text-3xl font-bold text-accent-800 mb-6">
              Transforming Gift Anxiety Into Gift Confidence
            </h3>
            <p className="text-accent-600 mb-6 leading-relaxed">
              Traditional gift-giving often feels overwhelming. With endless options and the pressure to find something meaningful, many people experience gift anxiety rather than gift joy.
            </p>
            <p className="text-accent-600 mb-8 leading-relaxed">
              Giftsy Modern changes this narrative by combining artificial intelligence with human insight, creating a platform that understands not just what people want, but why they want it and how it fits into their relationships.
            </p>
            
            <div className="bg-gradient-warm rounded-xl p-6 border border-primary-100">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="Quote" size={24} className="text-white" />
                </div>
                <div>
                  <p className="font-medium text-accent-800 mb-2">Our Founding Belief</p>
                  <p className="text-accent-600 italic">
                    "Every relationship deserves thoughtful celebration, and technology should make that celebration easier, not harder."
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <Image
              src="https://images.pexels.com/photos/6195121/pexels-photo-6195121.jpeg?w=600&h=400&fit=crop"
              alt="Diverse group of people sharing gifts and celebrating together"
              className="w-full h-96 lg:h-[450px] object-cover rounded-2xl shadow-lg"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent rounded-2xl"></div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {missionPoints.map((point, index) => (
            <div key={index} className="text-center group hover-lift">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-400 to-secondary-400 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <Icon name={point.icon} size={28} className="text-white" />
              </div>
              <h4 className="font-heading text-xl font-bold text-accent-800 mb-3">
                {point.title}
              </h4>
              <p className="text-accent-600 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionSection;